import { ObjectId } from 'bson';

const addDatasetToDataSpace = (dataSpace, datasetInstance) => {
	const updatedDataSpace = { ...dataSpace };

	// Update datasets
	updatedDataSpace.datasets = [...dataSpace.datasets, datasetInstance];

	// Update columnMetadata
	for (let column of datasetInstance.fields) {
		const newDatasetInstanceColumn = {
			_id: new ObjectId().toString(),
			field: column.name,
			header: column.displayName,
			dataSourceName: datasetInstance.name,
			description: column.description,
		};

		updatedDataSpace.columnMetadata.push(newDatasetInstanceColumn);
	}

	// Update joinData
	const joinDataDataset = {
		...datasetInstance,
		joins: [],
		isAnchor: !Boolean(updatedDataSpace.joinData.length),
	};
	delete joinDataDataset.fields;
	updatedDataSpace.joinData.push(joinDataDataset);

	return updatedDataSpace;
};

export default addDatasetToDataSpace;
